import { ArrowBack } from '@mui/icons-material'
import { Button, IconButton, Stack, Typography } from '@mui/material'
import { useCallback } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'

import DviPage from '../../components/DviPage/DviPage'
import DviVehicleUpdateButton from '../../components/Inspections/DviVehicleUpdateButton'
import { DviTitle } from '../../components/SharedUIDvi/DviTitle'
import { AppRoutes } from '../../models'
import { InspectionWithRelated } from '../../models/inspections'
import { CustomerEntry, RepairOrderExpanded, VehicleEntry } from '../../sdk'
import { formatName } from '../../utils/formatCustomerName/formatCustomerName'
import TechnicianSelect from '../SingleInspection/TechnicianSelect'

export const DviSingleInspectionSummaryContent = ({
  inspection,
  repairOrder,
  vehicle,
  customer,
  isLoading,
  handleStartInspection,
  handleAssignTech
}: {
  inspection: InspectionWithRelated | undefined
  repairOrder: RepairOrderExpanded | undefined
  vehicle: VehicleEntry | undefined
  customer: CustomerEntry | undefined
  isLoading: boolean
  handleStartInspection: (isReopen: boolean) => void
  handleAssignTech: (tech: string) => void
}) => {
  const navigate = useNavigate()
  const InspectionButton = useCallback(() => {
    if (inspection?.info!.finished) {
      return (
        <Button
          variant="contained"
          fullWidth
          onClick={handleStartInspection.bind(null, true)}>
          Reopen Inspection
        </Button>
      )
    }
    if (inspection?.info!.started) {
      return (
        <Button
          variant="contained"
          fullWidth
          onClick={() =>
            navigate(
              generatePath(AppRoutes.DVI_SINGLE_INSPECTION, {
                id: inspection.id!
              })
            )
          }>
          Resume Inspection
        </Button>
      )
    }
    return (
      <Button
        variant="contained"
        fullWidth
        onClick={handleStartInspection.bind(null, false)}>
        Start Inspection
      </Button>
    )
  }, [inspection?.info, inspection?.id, handleStartInspection, navigate])

  return (
    <DviPage
      isLoading={isLoading}
      title="Inspection Summary"
      actionsRight={
        <IconButton
          onClick={() => navigate(AppRoutes.DVI_INSPECTIONS)}
          sx={{ color: 'primary.light' }}>
          <ArrowBack />
        </IconButton>
      }>
      <DviTitle {...{ vehicle, repairOrder }} />
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        padding={2}>
        <Stack direction="row" alignItems="center" justifyContent="flex-start">
          <Typography variant="h4" paddingRight={2}>
            <b>Technician:</b>
          </Typography>
          <TechnicianSelect
            onlySetToSelf
            inspection={inspection}
            customUpdateTechHandler={handleAssignTech}
          />
        </Stack>
        <Typography variant="h4">
          <b>Customer: </b>
          {formatName(customer?.information)}
        </Typography>
        <Typography variant="h4">
          <b>RO Date: </b>
          {repairOrder?.entry?.created?.toLocaleDateString()}
        </Typography>
        <DviVehicleUpdateButton
          vehicleId={vehicle?.id}
          variant="outlined"
          mergeCallback={() => window.location.reload()}>
          Edit Vehicle Information
        </DviVehicleUpdateButton>
      </Stack>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="flex-start"
        padding={2}
        spacing={2}>
        <InspectionButton />
      </Stack>
    </DviPage>
  )
}
